var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgThreeDots = function SvgThreeDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 21",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.167 10.28a.083.083 0 100 .166.083.083 0 000-.167zm-1.584.082a1.583 1.583 0 113.167 0 1.583 1.583 0 01-3.167 0zM10 10.28a.083.083 0 100 .166.083.083 0 000-.167zm-1.583.082a1.583 1.583 0 113.166 0 1.583 1.583 0 01-3.166 0zm7.416-.082a.083.083 0 100 .166.083.083 0 000-.167zm-1.583.082a1.583 1.583 0 113.167 0 1.583 1.583 0 01-3.167 0z",
    fill: "#48525C"
  })));
};
export default SvgThreeDots;